import api from "@/util/api";

const state = {
  preferences: window.preferences,
}

const actions = {
  savePreference (context, params) {
    return api.post('/api/preference', [params]).then(response => {
      context.commit('setPreferences', response.data)
    })
  }
}

const mutations = {
  setPreferences (state, value) {
    state.preferences = value
  }
}

const getters = {
  PREFERENCE_VISIBLE_SHIFTS (state) {
    return state.preferences.VISIBLE_SHIFTS.value.split(',').map(i => parseInt(i))
  },
  DATE_RANGES () {
    let today = new Date()
    today.setHours(0, 0, 0, 0)
    let todayEnd = new Date()
    todayEnd.setHours(11, 59, 59, 999);

    let yesterdayStart = new Date()
    yesterdayStart.setDate(today.getDate() - 1)
    yesterdayStart.setHours(0, 0, 0, 0);

    let yesterdayEnd = new Date()
    yesterdayEnd.setDate(today.getDate() - 1)
    yesterdayEnd.setHours(11, 59, 59, 999);

    let thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    let thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999);

    let prevYearDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate());

    return {
      'Днес': [today, todayEnd],
      'Вчера': [yesterdayStart, yesterdayEnd],
      'Този месец': [thisMonthStart, thisMonthEnd],
      'Предния месец': [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)
      ],
      'Тази година': [
        new Date(today.getFullYear(), 0, 1),
        new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)
      ],
      'Една година назад': [
        prevYearDate,
        today,
      ],
    }
  }
}

export default {state, actions, mutations, getters}
